import { Select } from 'antd';
import React, { useEffect, useState } from 'react';

import { SelectProps } from 'antd/lib/select';
import { Option } from '../../../types';
import { capitalizeFirstLetter } from '../../../utils';
import { ProductType } from '../../../store/nutrition';

export default function SelectProductType({ ...props }: SelectProps<string, Option>): JSX.Element {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (ProductType) {
      setOptions(
        Object.values(ProductType)
          .map((type): Option => ({ label: capitalizeFirstLetter(type), value: type.toLowerCase() })),
      );
    }
  }, []);

  return (
    <Select options={options} placeholder="Please select" {...props} />
  );
}
